import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import { CommonBaseComponent } from "../common-base.component";
import {
  MedicalSchool,
  Residency,
  Fellowship,
  BoardCertification
} from "../../../../shared/models/my-account-data.models";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AddressComponent } from "../address/address.component";
import { AccountLookupComponent } from "../account-lookup/account-lookup.component";
import { AccountType, MemberType } from "../../../../shared/enums/data.enums";
import { GradDateComponent } from "../grad-date/grad-date.component";
import { Address } from "../../../../shared/models";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
  selector: "app-education-child",
  templateUrl: "./education-child.component.html",
  styleUrls: ["./education-child.component.scss"]
})
export class EducationChildComponent extends CommonBaseComponent {

  showAddress: boolean = false;

  ui_BoardCertifications = this.dataService.uidata.BoardCertifications;

  get specialityid() {
    return this.educationChild.get("specialityid");
  }
  get boardcertificationid() {
    return this.educationChild.get("boardcertificationid");
  }

  get address() {
    return this.educationChild.get("address");
  }

  get accountLookUp() {
    return this.educationChild.get("accountLookUp");
  }

  get graduation() {
    return this.educationChild.get("graduation");
  }

  get disableUI() {
    return this.educationChild.get("disableUI");
  }

  @Input() TITLE: string;

  @Input() accountType: AccountType;

  @Input() ui_Speciality: any;

  @Input() isInternational: boolean = true;



  //@Input() educationChild: FormGroup;

  private _educationChild: FormGroup;
  get educationChild(): FormGroup {
    return this._educationChild;
  }

  @Input("educationChild")
  set educationChild(value: FormGroup) {

    this._educationChild = value;

    this.UpdateAddressValidations();
  }


  onAccountSelected(_showAddress: boolean) {
    this.showAddress = _showAddress;
    // this.showAddress = account != null && account.isManual;
    // if (!this.showAddress) {
    //   this.address.setValue(new Address());
    // }
    // this.educationChild.patchValue({
    //   id: account ? account.accountId : "",
    //   name: account ? account.name : ""
    // });
    this.UpdateAddressValidations();
  }

  UpdateAddressValidations() {


    if (this.accountType == AccountType.BOARDCERTIFICATION) {
      this.showAddress = false;

      return;
    }
    let id = this.educationChild.get("accountLookUp.id").value;
    this.showAddress =
      this.dataService.uidata.ManualAccounts.filter(a => a.accountId == id)
        .length > 0;



    if (this.accountType == AccountType.RESIDENCY && this.showAddress) {

      if (!this.isInternational) {
        this.showAddress = false;
        this.globalDomOpsService.notify(
          "Residency program Not found. Please contact our Member and Customer Care to proceed further.",
          "",
          "error"
        );
        this.accountLookUp.reset();
      }
    }

    if (!this.showAddress) {
      this.address.disable();
    } else {
      this.address.enable();
    }

    this.helperService.markFormGroupUnTouched(this.address as FormGroup);
  }

  static buildForm_MS(a: MedicalSchool, fb: FormBuilder, memberType: MemberType, disableUI = false): FormGroup {
    let dateInFuture: boolean = (memberType == MemberType.Student);
    let validate: boolean = true;
    return fb.group({
      accountLookUp: AccountLookupComponent.buildForm(a, fb, validate),
      contacteducationchildid: a.contactmedicalschoolid,
      graduation: GradDateComponent.buildForm(a.graduationdate, fb, dateInFuture, validate),
      //OPTIONAL//
      address: AddressComponent.buildForm(a.address, fb, validate),
      metadata: a.metadata,
      disableUI: disableUI
    });
  }

  static buildForm_R(a: Residency, fb: FormBuilder, memberType: MemberType, validateGradDate = true, startEMBefore2000 = false, disableUI = false): FormGroup {
    let dateInFuture: boolean = (memberType == MemberType.Resident || memberType == MemberType.Student);
    let validate: boolean = (memberType != MemberType.Student) && validateGradDate && !startEMBefore2000;
    return fb.group({
      accountLookUp: AccountLookupComponent.buildForm(a, fb, validate),

      contacteducationchildid: a.contactresidencyid,

      graduation: GradDateComponent.buildForm(a.graduationdate, fb, dateInFuture, validate),
      specialityid: [a.specialtyid, validate ? Validators.required : []],

      //OPTIONAL//
      address: AddressComponent.buildForm(a.address, fb, validate),
      metadata: a.metadata,
      disableUI: disableUI
    });
  }

  static buildForm_F(a: Fellowship, fb: FormBuilder, memberType: MemberType, validateGradDate = true, disableUI = false): FormGroup {

    let dateInFuture: boolean = (memberType == MemberType.Student || memberType == MemberType.Resident || memberType == MemberType.Fellow);
    let validate: boolean = (memberType == MemberType.Fellow) && validateGradDate;;
    return fb.group({
      accountLookUp: AccountLookupComponent.buildForm(a, fb, validate),
      contacteducationchildid: a.contactfellowshipid,

      graduation: GradDateComponent.buildForm(a.graduationdate, fb, dateInFuture, validate),

      //OPTIONAL//
      address: AddressComponent.buildForm(a.address, fb, validate),
      metadata: a.metadata,
      disableUI: disableUI
    });
  }

  static buildForm_B(a: BoardCertification, fb: FormBuilder, memberType: MemberType): FormGroup {
    let validate: boolean = false;
    return fb.group({
      boardcertificationid: a.id,
      contacteducationchildid: a.contactboardcertificationid,

      graduation: GradDateComponent.buildForm(a.expirationdate, fb, null, validate),

      // //OPTIONAL//
      address: AddressComponent.buildForm(null, fb, validate)
      // metadata: a.metadata,

    });
  }
}
